//@ts-ignore
export const API_URL = 'https://gis.dongnai.gov.vn:82';

export let CONFIG = {
  titleMain: '',
  titleSub: '',
  backgroundUrl: '',
  logoUrl: '',
  webLinks: [],
  excelService:''
};
